import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { ApplicationConfigurationService } from "@app/core/services/ApplicationConfiguration.service";
import { PhmsAuditActivityEntry, PhmsAuditActivityPerspective } from "./phms-audit-activity.model";

const BASE_PATH = "/api/phms/audit-activity";

const quietHttpOptions = {
  headers: new HttpHeaders({
    "skip-error-interceptor": "yes",
    "skip-loading-interceptor": "yes",
  }),
  withCredentials: true,
};

@Injectable({ providedIn: "root" })
export class PhmsAuditActivityService {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(ApplicationConfigurationService);

  getActivity(
    perspectiveCode: PhmsAuditActivityPerspective,
    subjectId: number,
    take = 25,
  ): Observable<PhmsAuditActivityEntry[]> {
    const params = new HttpParams()
      .set("perspectiveCode", perspectiveCode)
      .set("subjectId", String(subjectId))
      .set("take", String(take));

    return this.http.get<PhmsAuditActivityEntry[]>(
      this.appConfig.apiUrl(BASE_PATH),
      { ...quietHttpOptions, params },
    );
  }
}
